import {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import { registrarEntradaInventarioUseCase } from "../../../core/inventarios/application/registrarEntradaInventario.usecase.js";
import { obtenerMovimientoInventarioUseCase } from "../../../core/inventarios/application/obtenerMovimientosInventario.usecase.js";

//

const InventarioMovimientoContext = createContext(null);

// Hook seguro para consumir el contexto
export const useInventarioMovimiento = () => {
  const context = useContext(InventarioMovimientoContext);
  if (!context) throw new Error("useInventarioMovimiento - Error provider");
  return context;
};

export function InventarioMovimientoProvider({ children }) {
  const [movimientoInventario, setMovimientoInventario] = useState([]);
  const [loading, setLoading] = useState(false);

  // ------------------------------------------
  // Listar movimientos del inventario
  // ------------------------------------------
  const listarMovimientoInventario = useCallback(async () => {
    setLoading(true);
    try {
      const data = await obtenerMovimientoInventarioUseCase();
      setMovimientoInventario(data);
      console.log("[obtenerMovimientoInventarioUseCase.InventarioMovimientoContext] Movimientos cargados:", data);
    } catch (error) {
      console.error("[obtenerMovimientoInventarioUseCase.InventarioMovimientoContext]Error listando:", error);
    } finally {
      setLoading(false);
    }
  }, []);



  // ------------------------------------------
  // Registrar un movimiento
  // ------------------------------------------
// Context
const registrarMovimiento = useCallback(async (payload) => {
  setLoading(true);
  try {
    const nuevoMovimiento = await registrarEntradaInventarioUseCase(payload);
    setMovimientoInventario(prev => [...prev, nuevoMovimiento]);
    return nuevoMovimiento;
  } finally { setLoading(false); }
}, []);

 // ------------------------------------------
  // Actualizar un movimiento existente
  // ------------------------------------------
  const actualizarMovimiento = useCallback(async (idMovimiento, datosActualizados) => {
    setLoading(true);
    try {
      const actualizado = await registrarEntradaInventarioUseCase(idMovimiento, datosActualizados);
      setMovimientoInventario(prev => prev.map(m => m.id_movimiento === idMovimiento ? actualizado : m));
      console.log("Movimiento actualizado:", actualizado);
      return actualizado;
    } catch (error) {
      console.error("Error actualizando movimiento:", error);
      throw error;
    } finally {
      setLoading(false);
    }
  }, []);

  /**
   * Carga inicial del inventario
   */
  useEffect(() => {
    listarMovimientoInventario();
  }, [listarMovimientoInventario]);

  return (
    <InventarioMovimientoContext.Provider
      value={{
        movimientoInventario,
        loading,
        registrarMovimiento,
        actualizarMovimiento,
        listarMovimientoInventario,
      }}
    >
      {children}
    </InventarioMovimientoContext.Provider>
  );
}
